import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { ContentDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.content";
import { getTaiwanUsageMap } from "@-/dev.improve.haniverse.data.taiwan-usage-map";
import { useMutation } from "@-/com.npmjs.tanstack__react-query";
import { createUserPronunciationCards } from "@-/dev.improve.haniverse.lib.cards.user-card.create";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";

/**
 * A pronunciation-level lesson's enrollment: the pronunciation cards of the readings the grapheme
 * introduces, leaving its (already enrolled) meaning card alone. See `createUserPronunciationCards`.
 * Pass `onlyPinyin` for a single-reading 2-P1 slot (干 gan4, then 干 gan1).
 */
export function useCreateUserPronunciationCards() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (c) => c.db);
  const [contentDb] = useContextSelectors(ContentDatabaseContext, (c) => c.db);
  const { hanziScript } = useActorUser();
  return useMutation({
    mutationFn: async ({
      graphemeCard,
      onlyPinyin,
      startedStudyingAt,
    }: {
      graphemeCard: { front: string };
      onlyPinyin?: string;
      startedStudyingAt?: string;
    }) =>
      createUserPronunciationCards({
        actorDb,
        contentDb,
        graphemeCard,
        hanziScript,
        onlyPinyin,
        startedStudyingAt,
        twUsageMap: getTaiwanUsageMap(),
      }),
    mutationKey: ["createUserPronunciationCards"],
  });
}
